import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';

const getAuthHeader = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    const token = user?.token;
    
    if (!token) {
        return {};
    }
    
    return {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    };
};

export const getAIResponse = async () => {
    const authHeader = getAuthHeader();
    const response = await axios.get(`${API_URL}/metrics/prediction`, authHeader);
    return response.data;
};

export const AIStatus = async () => {
    const authHeader = getAuthHeader();
    const response = await axios.get(`${API_URL}/ai_status`, authHeader);
    return response.data;
}

export const hasAIAccess = async () => {
    const authHeader = getAuthHeader();
    const response = await axios.get(`${API_URL}/has_ai_access`, authHeader);
    return response.data;
}

export const toggleAI = async () => {
    const authHeader = getAuthHeader();
    const response = await axios.post(`${API_URL}/toggle_ai`, {}, authHeader);
    return response.data;
}



export const activateUsersAi = async (userId) => {
    const authHeader = getAuthHeader();
    const response = await axios.post(`${API_URL}/grant_ai_access`, { userId }, authHeader);
    return response.data;
}

export const deactivateUsersAi = async (userId) => {
    const authHeader = getAuthHeader();
    const response = await axios.post(`${API_URL}/revoke_ai_access`, { userId }, authHeader);
    return response.data;
}

export const getAIUserStatus = async (userId) => {
    const authHeader = getAuthHeader();
    const response = await axios.get(`${API_URL}/admin/has_ai_access/${userId}`, authHeader);
    return response.data;
}

export const consistencyToggle = async () => {
    const authHeader = getAuthHeader();
    const response = await axios.post(`${API_URL}/toggle`, {}, authHeader);
    return response.data;
}

// premium section
export const consistencyStatus = async () => {
    const authHeader = getAuthHeader();
    const response = await axios.get(`${API_URL}/consistency-status`, authHeader);
    return response.data;
}

export const consistencyAdd = async (score = 0) => {
    const authHeader = getAuthHeader();
    const response = await axios.post(`${API_URL}/add/score`, { score }, authHeader);
    return response.data;
}

// Subscription APIs
export const consistencySubscriptionStatus = async () => {
    const authHeader = getAuthHeader();
    const response = await axios.get(`${API_URL}/consistency/my-subscription`, authHeader);
    return response.data;
}

export const consistencySubscriptionPackages = async () => {
    const authHeader = getAuthHeader();
    const response = await axios.get(`${API_URL}/consistency/packages`, authHeader);
    return response.data;
}

export const subscribeToPackage = async (packageId) => {
    const authHeader = getAuthHeader();
    const response = await axios.post(`${API_URL}/subscribe`, { packageId }, authHeader);
    return response.data;
}

export const getLatestConsistency = async () => {
    const authHeader = getAuthHeader();
    const response = await axios.get(`${API_URL}/latest/score`, authHeader);
    return response.data;
}

export const approveSubscription = async (userId, packageId, paymentReference) => {

    const authHeader = getAuthHeader();
    const response = await axios.post(`${API_URL}/consistency/approve-subscription`, {
        userId: parseInt(userId),
        packageId: parseInt(packageId),
        paymentReference: paymentReference
    }, authHeader);
    return response.data;
}

export const getAllSubscriptions = async () => {
    const authHeader = getAuthHeader();
    const response = await axios.get(`${API_URL}/consistency/subscriptions`, authHeader);
    return response.data;
}



